'use strict';

angular.module('user')
    .component('recoverPasswordSent', {
        templateUrl: 'js/modules/user/components/recover-password-sent/template.html',
    });
